import React from 'react';
import { Button, Form, Row, Col, Input, Modal } from 'antd';
//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction } from 'mobx';
import Getlnglat from '@/components/Getlnglat'

const App = () => {

    //mobx
    const { ShedsStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();

    //点X取消
    const onReset = () => {
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
        })
    };
    //表单重置
    //获取经纬度
    const getJd = () => {
        runInAction(() => {
            set(ShedsStore, { isJdWd: true })
        })
    }
    //经度纬度
    const getGetlnglat = (value) => {
        form.setFieldsValue({
            lat: value[0],
            lng: value[1],
        });
    }
    //点X取消
    const handleOk = () => {
        runInAction(() => {
            set(ShedsStore, { isJdWd: false })
        })
    };
    return (
        <>

            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                initialValues={
                    ShedsStore.seevalue
                }
            >
                <Form.Item
                    label="名称"
                >
                    {ShedsStore.seevalue.house_name}
                </Form.Item>
                <Form.Item label="地理坐标"
                >
                    <Row gutter={24}>
                        <Col span={8}>
                            <Form.Item noStyle name="lat"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入经度"
                                    },
                                ]}
                            >
                                <Input placeholder="经度" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item noStyle name="lng"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入纬度",
                                    },
                                ]}
                            >
                                <Input placeholder="纬度" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Button type='primary' onClick={getJd}>获取精纬度</Button>
                        </Col>
                    </Row>
                </Form.Item>
                <Modal
                    title="获取坐标"
                    bodyStyle={{ padding: '0' }}
                    key={new Date()}
                    width="800px"
                    open={ShedsStore.isJdWd}
                    onCancel={handleOk}
                    footer={null}
                >
                    <Getlnglat height='600px' value={[ShedsStore.valueData.lat, ShedsStore.valueData.lng]} onChange={getGetlnglat} />
                </Modal>
                <Form.Item
                    label="面积"
                >
                    {ShedsStore.seevalue.area}

                </Form.Item>
                <Form.Item
                    label="开始日期"
                >
                    {ShedsStore.seevalue.start_date}
                </Form.Item>
                <Form.Item
                    label="结束日期"
                >
                    {ShedsStore.seevalue.end_date}
                </Form.Item>
                <Form.Item
                    label="种植品种"
                >
                    {ShedsStore.seevalue.plant}
                </Form.Item>
                <Form.Item
                    label="编号"
                >
                    {ShedsStore.seevalue.code}
                </Form.Item>
                {/* <Form.Item
                    label="盛大大棚ID"
                >
                    {ShedsStore.seevalue.sdcode}
                </Form.Item> */}
                <Form.Item
                    label="视频观察地址"
                >
                    {ShedsStore.seevalue.videourl}
                </Form.Item>
            </Form>

        </>
    )
}

export default observer(App)